import { SxProps, Theme } from '@mui/material';

export const storeLocatorListSx: Record<string, SxProps<Theme>> = {
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
};

export const storeLocatorListDynamicSx: Record<string, (...args: any[]) => SxProps<Theme>> = {
	container: (isCurrentStore: boolean): SxProps<Theme> => ({
		...(isCurrentStore ? { order: '1' } : { order: '2' }),
	}),
};
